import React, { useEffect } from "react";

import { Grid, makeStyles, Typography } from "@material-ui/core/";
import { useSelector } from "react-redux";
import Aux from "../../../hoc/Auxilliary";
import mainLogo from "../../../assests/about.png";
import localizedStrings from "../../../utils/localize";

const useStyle = makeStyles((theme) => ({
  rootContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "3rem 0 5rem 0",
  },
  heading: {
    color: "#0692c9",
    fontSize: "24px",
    fontWeight: 600,
  },
  bodyMainContent: {
    display: "flex",
    justifyContent: "space-around",
  },
  bodyText: {
    fontSize: "18px",
    fontWeight: 400,
    color: "#005598 !important",
    marginTop: "1rem",
    width: "55%",
  },
  logoResponsive: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    width: "90%",
    opacity: "0.8",
    [theme.breakpoints.down("xs")]: {
      width: "50%",
      marginLeft: "0",
      display: "none",
    },
  },
}));

function About(props) {
  const classes = useStyle(props);

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  return (
    <Aux>
      <div className={classes.rootContainer}>
        <Typography component="h1" className={classes.heading}>
          Bienvenue au portail étudiant MonUSB
        </Typography>
        <Grid container item className={classes.bodyMainContent}>
          <Grid item xs={11} sm={9}>
            <Typography className={classes.bodyText}>
              Cette plateforme numérique offre un accès libre-service à ton
              dossier académique. Consulte ici tes notes de cours, ton horaire
              de cours et tes factures, et obtiens un soutien personnalisé en
              fixant un rendez-vous avec un de nos nombreux services à la
              population étudiante.
            </Typography>
          </Grid>
          <Grid item xs={11} sm={3}>
            <div className={classes.logoResponsive}>
              {/* <img src={mainLogo} width="50%" alt="oneWorld logo" /> */}
            </div>
          </Grid>
        </Grid>
      </div>
    </Aux>
  );
}

export default About;
